<div class = "container">
  <div class="loading-overlay" *ngIf="loading">
    <mat-progress-spinner mode="indeterminate" diameter="40" strokeWidth="3"></mat-progress-spinner>
  </div>

  <form class = "card-form"  [formGroup]="kycForm" (ngSubmit)="submitForm()" autocomplete="off" novalidate>
    <div class="blue-top" style="display: flex; align-items: center; box-sizing: border-box; padding: 24px; padding-top: 24px;">
      <h2 style="color: white!important; font-weight: 500; margin-bottom: 0px !important;" >
        {{pageHeading}}
      </h2>
    </div>
    <div class="card-section top-section">
      <h2>{{LanguagePack.detailsSubHeading}}</h2>
      <!-- Insurance Type -->
      <p>{{LanguagePack.insuranceQuestion}}</p>
      <section class="row-div modified_checkbox" formGroupName="insuranceType">
        <div class="row-inner-div row-inner-div-left">
          <mat-checkbox formControlName="individual" (change)="oninsuranceTypeIndividual()">{{LanguagePack.individualText}}</mat-checkbox>
        </div>
        <div class="row-inner-div row-inner-div-right">
          <mat-checkbox formControlName="corporate" (change)="oninsuranceTypeCorporate()">{{LanguagePack.corporateText}}</mat-checkbox>
        </div>
      </section>
      <!-- fullName -->
      <mat-form-field appearance="outline" class="form-select">
        <mat-label class="form-select-placeholder-unselected" >
          {{ kycForm.controls['insuranceType'].controls['individual'].value === true ? LanguagePack.fullNameLabel : LanguagePack.organizationNameLabel}}
        </mat-label>
        <input matInput formControlName="fullName" (blur)="logErrors()">
        <mat-error *ngIf="formErrors['fullName']">{{formErrors['fullName']}}</mat-error>
      </mat-form-field>
      <!-- Email -->
      <mat-form-field appearance="outline" class="form-select">
        <mat-label class="form-select-placeholder-unselected" >{{LanguagePack.emailLabel}}</mat-label>
        <input matInput formControlName="email" (blur)="logErrors()">
        <mat-error *ngIf="formErrors['email']">{{formErrors['email']}}</mat-error>
      </mat-form-field>
      <!-- Phone -->
      <mat-form-field appearance="outline" class="form-select">
        <mat-label class="form-select-placeholder-unselected" >{{LanguagePack.phoneLabel}}</mat-label>
        <input matInput formControlName="phone" (blur)="logErrors()">
        <mat-error *ngIf="formErrors['phone']">{{formErrors['phone']}}</mat-error>
      </mat-form-field>
      <!-- ID Number -->
      <mat-form-field appearance="outline" class="form-select">
        <mat-label class="form-select-placeholder-unselected" >{{idNumLabel}}</mat-label>
        <input matInput maxlength=9 formControlName="idNum" (blur)="logErrors()">
        <mat-error *ngIf="formErrors['idNum']">{{formErrors['idNum']}}</mat-error>
      </mat-form-field>
      <!-- Date of Birth (Individual) -->
      <mat-form-field appearance="outline" class="form-select" appFullYearDateFormat *ngIf="kycForm.controls['insuranceType'].controls['individual'].value === true">
        <mat-label class="form-select-placeholder-unselected">{{LanguagePack.dobLabel}}</mat-label>
        <input matInput  [min]="minDate" [max]="maxDate" [matDatepicker]="picker" readonly="true" (click)="picker.open()" formControlName="dob" (blur)="logErrors()">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker >
        </mat-datepicker>
      </mat-form-field>
      <!-- Gender -->
      <mat-form-field appearance="outline" class="form-select" *ngIf="kycForm.controls['insuranceType'].controls['individual'].value === true">
        <mat-label class="form-select-placeholder-unselected">
          {{LanguagePack.genderLabel}}
        </mat-label>
        <mat-select formControlName="gender" (blur)="logErrors()" panelClass="form-select-popup">
          <mat-option class="form-option" [value]="gender.value" *ngFor="let gender of GenderOptions">
            {{gender.view}}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="formErrors['gender']">{{formErrors['gender']}}</mat-error>
      </mat-form-field>
      <!-- Region -->
      <mat-form-field appearance="outline" class="form-select">
        <mat-label class="form-select-placeholder-unselected" >{{LanguagePack.regionLabel}}</mat-label>
        <input matInput formControlName="region" (blur)="logErrors()">
        <mat-error *ngIf="formErrors['region']">{{formErrors['region']}}</mat-error>
      </mat-form-field>
      <!-- District -->
      <mat-form-field appearance="outline" class="form-select">
        <mat-label class="form-select-placeholder-unselected" >{{LanguagePack.districtLabel}}</mat-label>
        <input matInput formControlName="district" (blur)="logErrors()">
        <mat-error *ngIf="formErrors['district']">{{formErrors['district']}}</mat-error>
      </mat-form-field>
      <!-- Postal Address -->
      <mat-form-field appearance="outline" class="form-select">
        <mat-label class="form-select-placeholder-unselected" >{{LanguagePack.adressLabel}}</mat-label>
        <input matInput formControlName="postalAddress" (blur)="logErrors()">
        <mat-error *ngIf="formErrors['postalAddress']">{{formErrors['postalAddress']}}</mat-error>
      </mat-form-field>
      <!-- Cover Start Date -->
      <mat-form-field appearance="outline" class="form-select" appFullYearDateFormat>
        <mat-label class="form-select-placeholder-unselected">{{LanguagePack.coverStartDateLabel}}</mat-label>
        <mat-hint>{{LanguagePack.coverStartDateDesc}}</mat-hint>
        <input matInput [min]="minCoverDate" [max]="maxCoverDate" (blur)="logErrors()" [matDatepicker]="coverPicker" readonly="true" (click)="coverPicker.open()" formControlName="coverStartDate">
        <mat-error *ngIf="formErrors['coverStartDate']">{{formErrors['coverStartDate']}}</mat-error>
        <mat-datepicker-toggle matSuffix [for]="coverPicker"></mat-datepicker-toggle>
        <mat-datepicker #coverPicker></mat-datepicker>
      </mat-form-field>

      <!-- Form Actions -->
      <div class="row-div" style="padding-top: 50px; padding-bottom: 20px;">
        <button mat-stroked-button type="button" (click)="confirmCancel()">
          <span class="button-text">{{LanguagePack.cancel}}</span>
        </button>
        <button mat-button type="submit" [disabled]="!kycForm.valid">
          <span class="button-text">{{LanguagePack.saveContinue}}</span>
        </button>
      </div>
    </div>
  </form>
</div>
